// extracted by mini-css-extract-plugin
export var input = "checkbox-module--input--2b4ff";
export var input_checkbox = "checkbox-module--input_checkbox--b81d9";
export var label = "checkbox-module--label--d17dc label-module--label--6013b";
export var label_radio = "checkbox-module--label_radio--004a4";